import { type MaybeRefOrGetter, toValue } from 'vue'
import { useMutationWithInvalidation } from '@/shared/composables/useMutationWithInvalidation'
import { approveTariffs } from './api/approveTariffs'
import { filterQueries, mainQueries } from './queries'
import type { TariffBandUpdate, TOUProfile } from './types';
import { saveTouProfile } from './api/saveTouProfile';
import { updateTariffs } from './api/updateTariffs';

export const useApproveTariffs = (
  ids: MaybeRefOrGetter<number[]>,
  yearOfTariff: MaybeRefOrGetter<string>
) =>
  useMutationWithInvalidation(
    (tariffIds: MaybeRefOrGetter<number[]>) => approveTariffs(toValue(tariffIds)),
    [
      mainQueries.fetchTariffs(ids, yearOfTariff).queryKey,
      filterQueries.fetchTariffYears(ids).queryKey
    ]
  );

export const useSaveTouProfile = (id: MaybeRefOrGetter<number>) =>
  useMutationWithInvalidation(
    (profile: MaybeRefOrGetter<TOUProfile[]>) => saveTouProfile(toValue(profile)),
    [
      mainQueries.fetchTOUProfile(id).queryKey
    ]
  );
export const useUpdateTariffs = (
  ids: MaybeRefOrGetter<number[]>,
  yearOfTariff: MaybeRefOrGetter<string>
) =>
  useMutationWithInvalidation(
    (recs: MaybeRefOrGetter<TariffBandUpdate[]>) => updateTariffs(toValue(recs)),
    [
      mainQueries.fetchTariffs(ids, yearOfTariff).queryKey,
      filterQueries.fetchTariffYears(ids).queryKey
    ]
  );
